var StyleGuide = (function () {
  

  Utility.log('styleGuideSlider js loaded');

  var $styleguideSlick = $.noop;

  function init() {
    setSlick();
    hideGhostUnderHeading();
  }

  function setSlick() {

    $styleguideSlick = $('.styleguide-slider').slick({
      autoplay: true,
      cssEase: 'linear',
      dots: true,
      infinite: true,
      nextArrow: '<svg class="acr-icon slick-prev slick-arrow"'
                + ' viewBox="0 0 26 26">'
                + '<use xmlns:xlink="http://www.w3.org/1999/xlink"'
                + ' xlink:href="#arrow-left">'
                + ' </use></svg>',
      prevArrow: '<svg class="acr-icon slick-next slick-arrow"'
                + ' viewBox="0 0 26 26">'
                + '<use xmlns:xlink="http://www.w3.org/1999/xlink"'
                + ' xlink:href="#arrow-right">'
                + '</use></svg>',
      speed: 200,
      useTransform: true,
      variableWidth: true,
    });
  }

  function hideGhostUnderHeading() {
    // if there is no text in .acr-heading > h6, hide .acr-heading so we don't get the red underline (.acr-underheading, child of .acr-heading) when there is no text to be underlined.
    var $acrHeading = $('.acr-heading');
    var $acrUnderheading = null;
    $acrHeading.each(function (index, element) {
      var $headingText = $('h6', $(element));
      if ($headingText && ($headingText.html() !== undefined) && ($headingText.html().length === 0)) {
        $acrUnderheading = $('.acr-underheading', $(element));
        if ($acrUnderheading !== undefined) {
          $acrUnderheading.css('display', 'none');
          // if it's under a parent div of class "mlp-shopping-tools-title"
          // hide that parent as well.
          var $parentElement = $(element).parents('.mlp-shopping-tools-title');
          if ($parentElement) {
            $parentElement.css('display', 'none');
          }
        }
      }
    });
  }

  return {
    init: init,
  };
}());
